export default "__VITE_ASSET__BH$J6zHT__"